import './modal-alert.scss';
//shared
import IModal from '../../interfaces/modal.interface';
//material
import { Button } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';

const Modal = ({ children,
    estatus,
    changeStatus,
    title,
    showHeader,
    buttonCancel,
    classNameModal,
    onClose
}: IModal) => {
    return (
        <>
            {estatus &&
                <div className='container-modal'>
                    <div className={`container-modal-body ${classNameModal}`}>
                        {showHeader &&
                            <div className='container-modal-header'>
                                <h1>{title}</h1>
                            </div>
                        }

                        {buttonCancel &&
                            <div className='close-button'>
                                <Button size='small' color='error' onClick={() => {
                                    if (onClose) onClose();
                                    changeStatus(false);
                                }}>
                                    <CloseIcon></CloseIcon>
                                </Button>
                            </div>
                        }
                        {children}
                    </div>
                </div>
            }
        </>
    );
}

export default Modal